module.exports = __webpack_public_path__ + "img/check-mark.d60af001.svg";